// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sellerdetails_tab_buttons__dXQPq {
  background-color: #0094ff;
  /* border: none; */
  outline: none;
  margin: 2px;
  padding: 6px;




}


.Sellerdetails_tabs__DwhuO {
  display: flex;
  flex-direction: row;
  background-color: white;
  justify-content: space-between;
}

.Sellerdetails_tab__Hm2Jk {
  height: 0;
  width: 33.33%;
  border-bottom: 35px solid #CCCCCC;
  border-right: unset;
  border-top-left-radius: none;
  box-sizing: border-box;
  /* display: block; */
  background: white;
  font-size: 14px;
  outline: none;
  line-height: 31px;
  border-top: none;
  border-left: none;
  font-size: 13px;
  /* border-top-left-radius: 6px; */
  font-weight: 600;
}



.Sellerdetails_tab__Hm2Jk:not(:first-child) {
  /* margin-left: -10px; */
  z-index: 0;
}

.Sellerdetails_tab__Hm2Jk .Sellerdetails_label__VUDaC {
  padding: 8px;
  text-align: center;
  /* color: #444444; */
  font-weight: 600;

}

.Sellerdetails_active__eB4mr {
  /* border-bottom: 35px solid #105293; */
  color: #105293;
  transition: 300ms;
  border-radius: 20px;
  border-bottom: 3px solid #105293;
}

.Sellerdetails_active__eB4mr .Sellerdetails_label__VUDaC {
  color: #ffffff;
}


/*  */


/* Add these styles to your stylesheet */

/* Style for the main container */
.Sellerdetails_taxlistTemplateDesc__cIUFS {
  /* border: 1px solid #ccc; */
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  box-shadow: 0px 0px 17px 4px rgb(0 0 0 / 10%);

}

/* Style for the Category section */

.Sellerdetails_taxlistTemplateDesc__cIUFS>div:last-child {
  display: flex;
  align-items: center;
  gap: 10px;
}

.Sellerdetails_taxlistTemplateDesc__cIUFS button {
  padding: 8px 15px;
  background-color: #3498db;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.Sellerdetails_taxlistTemplateDesc__cIUFS {
  padding: 15px;
  margin: 10px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.Sellerdetails_taxlistTemplateDesc__cIUFS img {
  width: 50%; 
  height: auto; 
}

.Sellerdetails_taxlistTemplateDesc__cIUFS .Sellerdetails_form-check__EZB85 {
  margin-left: auto;
}

.Sellerdetails_taxlistTemplateDesc__cIUFS .Sellerdetails_badge__GkaGL.Sellerdetails_btn__n2Jt1 {
  cursor: not-allowed;
}

.Sellerdetails_row__yeGI5 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SellerDetails/Sellerdetails.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;;;;;AAKd;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;;;AAIA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;;AAElB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;;AAGA,KAAK;;;AAGL,wCAAwC;;AAExC,iCAAiC;AACjC;EACE,4BAA4B;EAC5B,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;;AAE/C;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC","sourcesContent":[".tab_buttons {\n  background-color: #0094ff;\n  /* border: none; */\n  outline: none;\n  margin: 2px;\n  padding: 6px;\n\n\n\n\n}\n\n\n.tabs {\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  justify-content: space-between;\n}\n\n.tab {\n  height: 0;\n  width: 33.33%;\n  border-bottom: 35px solid #CCCCCC;\n  border-right: unset;\n  border-top-left-radius: none;\n  box-sizing: border-box;\n  /* display: block; */\n  background: white;\n  font-size: 14px;\n  outline: none;\n  line-height: 31px;\n  border-top: none;\n  border-left: none;\n  font-size: 13px;\n  /* border-top-left-radius: 6px; */\n  font-weight: 600;\n}\n\n\n\n.tab:not(:first-child) {\n  /* margin-left: -10px; */\n  z-index: 0;\n}\n\n.tab .label {\n  padding: 8px;\n  text-align: center;\n  /* color: #444444; */\n  font-weight: 600;\n\n}\n\n.active {\n  /* border-bottom: 35px solid #105293; */\n  color: #105293;\n  transition: 300ms;\n  border-radius: 20px;\n  border-bottom: 3px solid #105293;\n}\n\n.active .label {\n  color: #ffffff;\n}\n\n\n/*  */\n\n\n/* Add these styles to your stylesheet */\n\n/* Style for the main container */\n.taxlistTemplateDesc {\n  /* border: 1px solid #ccc; */\n  padding: 15px;\n  margin: 10px;\n  border-radius: 8px;\n  box-shadow: 0px 0px 17px 4px rgb(0 0 0 / 10%);\n\n}\n\n/* Style for the Category section */\n\n.taxlistTemplateDesc>div:last-child {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.taxlistTemplateDesc button {\n  padding: 8px 15px;\n  background-color: #3498db;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.taxlistTemplateDesc {\n  padding: 15px;\n  margin: 10px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.taxlistTemplateDesc img {\n  width: 50%; \n  height: auto; \n}\n\n.taxlistTemplateDesc .form-check {\n  margin-left: auto;\n}\n\n.taxlistTemplateDesc .badge.btn {\n  cursor: not-allowed;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab_buttons": `Sellerdetails_tab_buttons__dXQPq`,
	"tabs": `Sellerdetails_tabs__DwhuO`,
	"tab": `Sellerdetails_tab__Hm2Jk`,
	"label": `Sellerdetails_label__VUDaC`,
	"active": `Sellerdetails_active__eB4mr`,
	"taxlistTemplateDesc": `Sellerdetails_taxlistTemplateDesc__cIUFS`,
	"form-check": `Sellerdetails_form-check__EZB85`,
	"badge": `Sellerdetails_badge__GkaGL`,
	"btn": `Sellerdetails_btn__n2Jt1`,
	"row": `Sellerdetails_row__yeGI5`
};
export default ___CSS_LOADER_EXPORT___;
